/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import StructureOptionsData from '@Services/StructureOptionsData';
import StructureContainers from '@Services/StructureContainers';
import PropTypes from 'prop-types';
import './StructureOptionsBadges.custom.scss';
import { connect } from 'react-redux';
import { selectedOptionsNameValueObjectsArray as selectedOptionsNameValueObjectsArraySelector } from '@Containers/StructureOptions/StructureOptionsSelecors';
import { updateStructureOptionsDialog as updateStructureOptionsDialogAction } from '@Containers/StructureOptions/StructureOptionsDialog/StructureOptionsDialogActions';
import { fetchAndCreateInitialOptionsCopy as fetchAndCreateInitialOptionsCopyAction } from '@Containers/StructureOptions/StructureOptionsActions';
import { Icon } from '@els/els-react--icon';

function StructureOptionsBadges({
  id,
  updateStructureOptionsCallback,
  onSavedOptionsChange,
  structureOptions,
  savedOptions,
  openStructureOptionsDialog,
  fetchAndCreateInitialOptionsCopy,
}) {
  const BADGES_IN_ONE_LANE = 3;
  const [badges, setBadges] = useState([]);
  const [ellipsisView, setEllipsisView] = useState(false);
  const [firstBadge, setFirstBadge] = useState(null);
  const [lastBadge, setLastBadge] = useState(null);

  function updateBadges(data) {
    const newBadges = StructureOptionsData.calculateBadges(data);
    setBadges(newBadges);

    if (newBadges.length > BADGES_IN_ONE_LANE) {
      setEllipsisView(true);
      setFirstBadge(newBadges[0]);
      setLastBadge(newBadges[newBadges.length - 1]);
    } else {
      setEllipsisView(false);
    }
  }

  async function updateStructureOptions(optionsList) {
    if (typeof onSavedOptionsChange === 'function') {
      onSavedOptionsChange(optionsList);
    }
    StructureOptionsData.restoreOptions(optionsList).then(updateBadges);
    await StructureContainers.updateContainerOptions(id, optionsList).catch(Logger.reject);

    if (typeof updateStructureOptionsCallback === 'function') {
      updateStructureOptionsCallback();
    }
  }

  useEffect(() => {
    updateStructureOptions(savedOptions);
  }, [savedOptions]);

  const initialize = async () => {
    if (structureOptions) {
      fetchAndCreateInitialOptionsCopy(id, structureOptions.length ? structureOptions : undefined).catch(Logger.error);
    } else {
      StructureContainers.getContainerOptions(id)
        .then((data) => {
          fetchAndCreateInitialOptionsCopy(id, data && data.length ? data : undefined);
        })
        .catch(Logger.error);
    }
  };

  useEffect(() => {
    initialize();
  }, []);

  const openOptionsModal = () => {
    openStructureOptionsDialog({ id });
  };

  const buttonText = () =>
    (!ellipsisView && badges.map((badge) => <span key={badge}>{badge}</span>)) ||
    (!!ellipsisView && <span>{firstBadge}</span>) ||
    (!!ellipsisView && <span className="ellipsis-tag">...</span>) ||
    (!!ellipsisView && <span>{lastBadge}</span>);

  return (
    <div
      className="search-structure-tags"
      title="Click to change options"
      onClick={openOptionsModal}
      tabIndex={0}
      role="button"
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          openOptionsModal();
        }
      }}>
      <span className="structure-options-badges">{buttonText()}</span>

      <Icon
        sprite="Edit"
        color="secondary"
        a11y={{
          name: 'Edit Options',
          description: 'Click to change options',
        }}
        id="querybuilder-editstructureconfig-button">
        Edit options
      </Icon>
    </div>
  );
}

const mapStateToProps = (state, ownProps) => ({
  savedOptions: selectedOptionsNameValueObjectsArraySelector(state, ownProps),
});

const mapDispatchToProps = {
  openStructureOptionsDialog: updateStructureOptionsDialogAction,
  fetchAndCreateInitialOptionsCopy: fetchAndCreateInitialOptionsCopyAction,
};

StructureOptionsBadges.propTypes = {
  id: PropTypes.string,
  onSavedOptionsChange: PropTypes.func,
  structureOptions: PropTypes.array,
  savedOptions: PropTypes.array,
  openStructureOptionsDialog: PropTypes.func,
  fetchAndCreateInitialOptionsCopy: PropTypes.func,
  updateStructureOptionsCallback: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(StructureOptionsBadges);
